import type { ReactElement } from 'react';
import { Programmuebersicht } from '../programmuebersicht/Programmuebersicht';

/** PHQ-111: Die Prozesslandkarte wurde durch die Programmübersicht ersetzt.
 *  Die Route (`prozesslandkarte`) bleibt bestehen. */
export function ProzesslandkartePage(_props: { projectId: string }): ReactElement {
  return <Programmuebersicht />;
}
